/* FR-JS · pied de page (W1f, 30 sept. 2026) : sur téléphone, chaque rubrique du menu se replie derrière un bouton.
   Le bouton recouvre le titre (CSS, ≤ 749 px) ; au-dessus, le bouton est masqué et tout reste affiché. */
(function () {
  var foot = document.querySelector('.jp-foot');
  if (!foot || foot.classList.contains('jp-foot--fold')) return;
  var groups = foot.querySelectorAll('.jp-foot__navigation > .jp-foot__group');
  Array.prototype.forEach.call(groups, function (group, i) {
    var heading = group.querySelector(':scope > h2');
    var list = group.querySelector(':scope > .jp-foot__links');
    if (!heading || !list) return;
    if (!list.id) list.id = 'JpFootList-' + i;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'jp-ffold';
    button.setAttribute('aria-controls', list.id);
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', heading.textContent.replace(/\s+/g, ' ').trim());
    button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>';
    button.addEventListener('click', function () {
      var open = group.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    heading.insertAdjacentElement('afterend', button);
  });
  foot.classList.add('jp-foot--fold');
})();
